const stringUtil = {
    /**
     * 컴마를 포함한 숫자로 변환한다
     * @param num 숫자
     * @param scale 소수점 자리수
     * @returns 컴마를 포함한 숫자
     */
    toCommaNumber: (num: string | number | null | undefined, scale: number = 0): string => {
        let number = Number(num);

        if (isNaN(number)) {
            number = 0;
        }

        return number.toLocaleString('en', {
            style: 'decimal',
            minimumFractionDigits: scale,
            maximumFractionDigits: scale,
        });
    },
    /**
     * 짧은 단위의 원화로 변환한다
     * @param num 숫자
     * @param precision 소수점 자리수
     * @returns 원화
     */
    toCompactKrw: (num: string | number | null | undefined, precision: number = 1): string => {
        let number = Number(num);

        if (isNaN(number)) {
            number = 0;
        }

        return number.toLocaleString('ko', {
            style: 'currency',
            currency: 'KRW',
            // "$100" rather than "US$100"
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
            notation: 'compact',
        });
    },
    /**
     * 짧은 단위의 달러로 변환한다
     * @param num 숫자
     * @param precision 소수점 자리수
     * @returns 달러
     */
    toCompactUsd: (num: string | number | null | undefined, precision: number = 1): string => {
        let number = Number(num);

        if (isNaN(number)) {
            number = 0;
        }

        return number.toLocaleString('en', {
            style: 'currency',
            currency: 'USD',
            // "$100" rather than "US$100"
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
            notation: 'compact',
        });
    },
    /**
     * 비중을 퍼센트로 변환한다
     * @param weight 비중
     * @returns 퍼센트
     */
    toPercentage: (weight: string | number | null | undefined, scale: number = 2): string => {
        let number = Number(weight);

        if (isNaN(number)) {
            number = 0;
        }

        return number.toLocaleString('en', {
            style: 'percent',
            minimumFractionDigits: scale,
            maximumFractionDigits: scale,
        });
    },
};
export default stringUtil;
